import React from 'react';

const LogoText = ({children, classes}) => {
  return (
    <h2 className={classes}>{children}</h2>
  )
};

export default LogoText;
